export default __webpack_public_path__ + "static/media/BABY.978c7d04.svg";